import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class ModalController extends Controller {
  static targets = ['modal']

  constructor (context) {
    super(context)
    if (this.hasModalTarget) {
      this.modal = new Modal(this.modalTarget)
    }
  }

  openModal () {
    if (this.hasModalTarget) {
      this.modal.show()
    }
  }

  closeModal () {
    if (this.hasModalTarget) {
      this.modal.hide()
    }
  }
}
